/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable quotes */
import { storeDBLogData } from '../../shared/api/url-helper';
// Utility: find only changed fields
const getChangedFields = (oldRow, newRow) => {
    const changes = {};
    Object.keys(newRow).forEach((key) => {
        if (oldRow[key] !== newRow[key]) {
            changes[key] = newRow[key];
        }
    });
    return changes;
};

export const logUserOperation = ({
    operation_type,
    table_name,
    primary_key,
    old_row_data,
    new_row_data,
    deleted_row_data,
    user_id,
    userName_id
}) => {
    const now = new Date();
    const timeStr = now.toLocaleString(); // full timestamp

    const userInfo = {
        user_email: user_id,
        user_name: userName_id,
        time_stamp: timeStr,
        operation_type,
        table_name
    };

    let logEntry;

    if (operation_type === 'add') {
        logEntry = {
            ...userInfo,
            added_newRow_details: new_row_data
        };
    } else if (operation_type === 'update') {
        const changedFields = getChangedFields(old_row_data, new_row_data);
        logEntry = {
            ...userInfo,
            primary_key,
            old_row_data,
            updated_new_row_data: changedFields
        };
    } else if (operation_type === 'delete') {
        logEntry = {
            ...userInfo,
            primary_key,
            deletion_of_row_details: deleted_row_data
        };
    }

    // ---- Send only the new log entry to API ----
    try {
        storeDBLogData([logEntry]).then(() => {
            console.log("Log stored in S3:");
        });
    } catch (err) {
        console.error("Failed to save log via API", err);
    }
};
